document.addEventListener('DOMContentLoaded', (event) => {

    function removeAllNoScript() {
        document.querySelectorAll('noscript').forEach(ns => ns.remove());
    }
    removeAllNoScript();

    function hideBrs() {
        document.querySelectorAll('br').forEach(br => br.setAttribute('aria-hidden', 'true'));
    }
    hideBrs();

    function fixMenu() {

        const summary = document.querySelector('.header__icon--menu');
        if(summary) {
            const details = summary.parentElement;
            const closeBtn = document.querySelector('.close-ally');
            const menuContainer = document.querySelector('#menu-drawer')
            // 2. Listen for when it opens or closes
            if (details) {
                const keydownFocus = () => {
                closeBtn.focus();
                };

                closeBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                summary.click();
                });
        
                closeBtn.addEventListener('keydown', (e) => {
                if(e.key === 'Enter') {
                    e.preventDefault();
                    e.stopPropagation();
                    summary.click();
                }

                });

            details.addEventListener('toggle', (event) => {
                if (details.open) {
                setTimeout(() => {
                    closeBtn.focus();
                }, 300);
                summary.addEventListener('focus', keydownFocus);

                } else {
                summary.removeEventListener('focus', keydownFocus);
                summary.focus();
                }
            });
            }
        }
    }

fixMenu();

    function fixBoostSearchAccessibility() {

        function init(inputSelector, wrapperSelector) {
            const searchInput = document.querySelector(inputSelector);
            const resultsContainer = document.querySelector(wrapperSelector);
            if (!searchInput || !resultsContainer) {
                setTimeout(() => {
                    init(inputSelector, wrapperSelector);
                }, 500);
                return;
            }


            const itemSelector = '.boost-pfs-search-suggestion-item, .boost-pfs-search-suggestion-header-view-all';
            const selectedClass = 'boost-pfs-search-suggestion-item.selected';

            resultsContainer.setAttribute('aria-label', 'Search results');
            if (searchInput.id === 'boost-pfs-search-box-1') {
                searchInput.removeAttribute('placeholder');
            }
            searchInput.setAttribute('aria-label', 'Search')

            let isObserving = false;

            const observer = new MutationObserver(() => {
                const isVisible = resultsContainer.style.display !== 'none' &&
                    resultsContainer.innerHTML.trim() !== '' &&
                    resultsContainer.offsetParent !== null;

                searchInput.setAttribute('aria-expanded', isVisible ? 'true' : 'false');

                const activeItem = resultsContainer.querySelector('.' + selectedClass);
                const allItems = resultsContainer.querySelectorAll(itemSelector);

                allItems.forEach((item, index) => {
                    if (item.getAttribute('role') !== 'option') {
                        item.setAttribute('role', 'option');
                    }
                    if (!item.id) item.id = 'boost-option-' + index;
                    const link = item.querySelector('a');
                    if (link) link.setAttribute('tabindex', '-1');
                });

                if (activeItem) {
                    if (!activeItem.id) {
                        activeItem.id = 'boost-selected-option-' + Date.now();
                    }
                    searchInput.setAttribute('aria-activedescendant', activeItem.id);
                    activeItem.setAttribute('aria-selected', 'true');
                    const activeLink = activeItem.querySelector('a');
                    if (activeLink) activeLink.setAttribute('tabindex', '0');
                } else {
                    searchInput.removeAttribute('aria-activedescendant');
                    allItems.forEach(i => i.setAttribute('aria-selected', 'false'));
                }
            });

            function startObserver() {
                if (isObserving) return;
                observer.observe(resultsContainer, {
                    attributes: true,
                    childList: true,
                    subtree: true,
                    attributeFilter: ['class', 'style']
                });
                isObserving = true;
            }

            function stopObserver() {
                if (!isObserving) return;
                observer.disconnect();
                isObserving = false;
                searchInput.setAttribute('aria-expanded', 'false');
                searchInput.removeAttribute('aria-activedescendant');
            }

            searchInput.addEventListener('focus', () => {
                startObserver();
                const isVisible = resultsContainer.style.display !== 'none';
                searchInput.setAttribute('aria-expanded', isVisible ? 'true' : 'false');
            });

            searchInput.addEventListener('blur', () => {
                stopObserver();
            });
        }

        const run = () => {
            init('#Search-In-Modal', '#predictive-search-results');
        };

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', run);
        } else {
            run();
        }
    }

    fixBoostSearchAccessibility();

    (function replaceLabelWithSpanInVerificationModal() {
        function replaceElement(el) {
            const span = document.createElement('span');

            for (const attr of el.attributes) {
            span.setAttribute(attr.name, attr.value);
            }

            span.innerHTML = el.innerHTML;

            el.replaceWith(span);
        }

        const el = document.querySelector('#data-verification-icon');
        if (!el) return;
        replaceElement(el);

    })();


    function makeSliderTenCollectionGridOnMobile() {
        const tentGridWrapper = document.getElementById('tentGridWrapper');
        if(!tentGridWrapper || window.innerWidth > 1023) return

        tentGridWrapper.setAttribute('role', 'region');
        const slides = tentGridWrapper.querySelectorAll('.tent-card-wrapper');
        slides.forEach((slide, index) => {
            slide.setAttribute('role', 'group');
            slide.setAttribute('aria-label', `Slide ${index + 1} of ${slides.length}`)
        });

        appendSliderArrows(slides, tentGridWrapper);
        intersectionObserverAda(slides, tentGridWrapper);
        
    }

    function appendSliderArrows(slides, wrapperContainer) {
        /* --------------------
            Create arrows
        --------------------- */
        const controls = document.createElement('div');
        controls.className = 'tent-slider-controls';
        controls.setAttribute('role', 'group');
        controls.setAttribute('aria-label', 'Slider controls');

        const prevBtn = document.createElement('button');
        prevBtn.type = 'button';
        prevBtn.className = 'tent-slider-prev';
        prevBtn.setAttribute('aria-label', 'Previous slide');
        prevBtn.innerHTML = `
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
        `;

        const nextBtn = document.createElement('button');
        nextBtn.type = 'button';
        nextBtn.className = 'tent-slider-next';
        nextBtn.setAttribute('aria-label', 'Next slide');
        nextBtn.innerHTML = `
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
        `;

        controls.append(prevBtn, nextBtn);
        wrapperContainer.after(controls);
        let currentIndex = 0;

        function moveTo(index) {
            currentIndex = Math.max(0, Math.min(index, slides.length - 1));

            slides[currentIndex].scrollIntoView({
                behavior: 'smooth',
                inline: 'start',
                block: 'nearest'
            });
        }

        prevBtn.addEventListener('click', () => moveTo(currentIndex - 1));
        nextBtn.addEventListener('click', () => moveTo(currentIndex + 1));
    }

    makeSliderTenCollectionGridOnMobile();

    function listenToCircularCollectionVisibilitySlider() {
        document.querySelectorAll('.product-collections-carousel-wrapper').forEach(slider => {
            const slides = slider.querySelectorAll('.product-collection-card');
            if(slides.length > 0) {
                intersectionObserverAda(slides, slider);
            }
        });
    }

    listenToCircularCollectionVisibilitySlider();

    function addSliderSemanticsToProductsGrid() {
        if(window.innerWidth > 767) return

        document.querySelectorAll('.products-grid').forEach(grid => {
            grid.setAttribute('role', 'region');
            const slides = grid.querySelectorAll('.product-card');
            slides.forEach((item, index) => {
                item.setAttribute('role', 'group');
                item.setAttribute('aria-label', `Slide ${index + 1} of ${slides.length}`);
            });

            appendSliderArrows(slides, grid);
            intersectionObserverAda(slides, grid);
        });
    }

    addSliderSemanticsToProductsGrid();

    function fixShopingCartModalItems() {
        const cartObs = new MutationObserver(() => {
            const cart = document.querySelector('.picky-cart__content');
            if(!cart) return;
            const counter = cart.querySelector('.picky-cart__counter');
            console.log(counter, 'counter1')
            if(counter) {
                const itemsText = document.createElement('span');
                itemsText.classList.add('visually-hidden-ada');
                itemsText.innerText = 'items';
                counter.append(itemsText);
                new MutationObserver(() => {
                    const alreadyAdded = counter.querySelector('.visually-hidden-ada');
                    if(!alreadyAdded) {
                        counter.append(itemsText);
                    }
                }).observe(counter, {
                    subtree: true,
                    childList: true
                });
            }
            const discountBtn =  cart.querySelector('.picky-cart__footer .picky-add-discount-field__button');
            if(discountBtn) {
                discountBtn.addEventListener('click', () => {
                    const discountContainer = document.querySelector('#picky-cart-sidebars-container');
                    const closeBtn = discountContainer.querySelector('.picky-remove-button');
                    if(closeBtn) {
                        closeBtn.setAttribute('aria-label', 'Close');
                    }

                    const input = discountContainer.querySelector('input');
                    if(input) {
                        input.setAttribute('aria-label', 'Discount code');
                    }
                });
            }


            const observer = new MutationObserver(mutations => {
            for (const { addedNodes } of mutations) {
                for (const node of addedNodes) {
                if (!(node instanceof HTMLElement)) continue;

                const items = node.matches?.('.picky-product-card.picky-cart-item')
                    ? [node]
                    : node.querySelectorAll?.('.picky-product-card.picky-cart-item') || [];

                items.forEach(item => {
                    if (item.dataset.observed) return; // prevent duplicates
                    item.dataset.observed = 'true';

                    const title = item.querySelector('.picky-title');
                    title.id = 'ADA_title_id_'+ Math.random().toString(36).substring(2, length + 2);
                    const quantityContainer = item.querySelector('.picky-quantity');
                    if(quantityContainer) {
                        quantityContainer.querySelectorAll('button').forEach(btn => {
                            btn.setAttribute('aria-describedby', title.id);
                            btn.setAttribute('aria-label', btn.classList.contains('picky-quantity__decrease-button') ? 'Decrease quantity' : 'Increase quantity');
                        })
                    }

                    const removeBtn = item.querySelector('.picky-cart-item__remove-button');
                    if(removeBtn) {
                        removeBtn.setAttribute('aria-describedby', title.id);
                    }
                    setTimeout(() => {
                        const bundleContainer = item.nextElementSibling;

                        if(bundleContainer && bundleContainer.className.includes('_root_')) {

                            const expandBtn = bundleContainer.querySelector('button');
                            if(expandBtn) {
                                const iconSpan = expandBtn.querySelector('span');
                                iconSpan.setAttribute('aria-hidden', 'true');
                                const updateExpanded = () => {
                                    expandBtn.setAttribute('aria-expanded', bundleContainer.className.includes('opened') ? 'true' : 'false');
                                }

                                updateExpanded();

                                expandBtn.addEventListener('click', () => {
                                    updateExpanded();
                                });

                                expandBtn.addEventListener('keydown', (e) => {
                                    if(e.key === 'Enter') {
                                        expandBtn.click();
                                    }
                                })
                            }

                            const list = bundleContainer.querySelector('[class^="_items_"]');
                            list.setAttribute('role', 'list');
                            list.querySelectorAll('[role="link"]').forEach(link => {
                                link.removeAttribute('role');
                                link.removeAttribute('aria-label');
                            });
                            list.setAttribute('aria-label', 'Bundle')
                            list.querySelectorAll(':scope > div').forEach(listitem => {
                                listitem.setAttribute('role', 'listitem');
                            });

                            const priceContainer = bundleContainer.querySelector('.picky-totals__prices-wrapper');
                            const salePrice = priceContainer.querySelector('.picky-totals__compare-at-price');
                            console.log(salePrice)
                            if(salePrice) {
                                const regularText = document.createElement('span');
                                regularText.innerText = 'Regular price';
                                regularText.classList.add('visually-hidden-ada');
                                salePrice.prepend(regularText);

                                const currentPrice = priceContainer.querySelector('.picky-totals__price');
                                if(currentPrice) {
                                    const saleText = document.createElement('span');
                                    saleText.innerText = 'Sale price';
                                    saleText.classList.add('visually-hidden-ada');
                                    currentPrice.prepend(saleText);
                                }

                            }
                            
                            const footer = bundleContainer.querySelector('[class^="_footer_"]');
                            if(footer) {
                                const addBundleBtn = footer.querySelector('button');
                                if(addBundleBtn) {
                                    addBundleBtn.setAttribute('aria-label', 'Add bundle');
                                }
                            }
                        }
                    }, 2000);
                });
                }
            }
            });

            observer.observe(cart, {
                childList: true,
                subtree: true
            });




            cartObs.disconnect();
        })
        cartObs.observe(document.body, {subtree: true, childList: true})
    }
    fixShopingCartModalItems();

    function fixTolstoyCarousel() {
        const tolStoyObs = new MutationObserver(() => {
            const container = document.querySelector('.tolstoy-carousel-videos-container');
            if(!container) return;
            
            setTimeout(() => {
                const slides = container.querySelectorAll('[role="group"]');
                slides.forEach(slide => {
                    if(slide.getAttribute('tabindex')) {
                        slide.removeAttribute('tabindex');
                        const video = slide.querySelector('video');
                        video?.removeAttribute('tabindex');

                        const toggleBtn = slide.querySelector('.tolstoy-carousel-play-button');
                        if(toggleBtn) {
                            toggleBtn.addEventListener('click', () => {
                                if (video.paused) {
                                    video.play();
                                    toggleBtn.setAttribute('aria-label', 'Pause video');
                                } else {
                                    video.pause();
                                    toggleBtn.setAttribute('aria-label', 'Play video');
                                }
                            })
                        }

                        slide.querySelectorAll('.tolstoy-product-tile').forEach(tile => {
                            const img = tile.querySelector('img');
                            img?.setAttribute('alt', '');

                            const price = tile.querySelector('.tolstoy-product-tile-price');
                            const salePrice = price.querySelector('span');
                            if(salePrice) {
                                const regularText = document.createElement('span');
                                regularText.innerText = 'Regular price';
                                regularText.classList.add('visually-hidden-ada');
                                salePrice.prepend(regularText);

                                const saleText = document.createElement('span');
                                saleText.innerText = 'Sale price';
                                saleText.classList.add('visually-hidden-ada');
                                salePrice.after(saleText);
                            }
                            
                        })

                        const isHidden = slide.getAttribute('aria-hidden') === 'true';
                        slide.querySelectorAll('button, [tabindex]').forEach(btn => {
                            btn.setAttribute('tabindex', isHidden ? '-1' : '0');
                        });
                    }
                });


                container.querySelectorAll('[role="group"]').forEach(slide => {
                    new MutationObserver(() => {
                        if(slide.getAttribute('tabindex')) {
                            slide.removeAttribute('tabindex');
                            const video = slide.querySelector('video');
                            video?.removeAttribute('tabindex');
                        }
                        
                    }).observe(slide, {
                        attributes: true,
                        attributeFilter: ['tabindex']
                    });
                });
            }, 1000);

            tolStoyObs.disconnect();
        })
        tolStoyObs.observe(document.body, {subtree: true, childList: true})
    }
    fixTolstoyCarousel();

    function listenToCartModalOpener() {
        const openBtn = document.querySelector('#cart-icon-bubble');
        if(openBtn) {
            const update = () => {
                const realOpenEl = openBtn.querySelectorAll('[data-picky-cart-button-area]')[1];
                if(realOpenEl) {
                    realOpenEl.click();
                }
            }
            openBtn.addEventListener('click', () => {
                update();
            })
            openBtn.addEventListener('keydown', (e) => {
                if(e.key === 'Enter') {
                    update();
                }
            })
        }
    }

    listenToCartModalOpener();

    function listenToCardLinks() {
        document.querySelectorAll('.tent-card-wrapper').forEach(product => {
            product.addEventListener('click', () => {
                product.querySelector('a').click();
            });
            
        });
    }

    listenToCardLinks();

    function intersectionObserverAda(slides, parent, visibilityPercentage = 0.9) {
        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    const isVisible = entry.intersectionRatio >= visibilityPercentage;
                    entry.target.setAttribute(
                    'aria-hidden',
                    isVisible ? 'false' : 'true'
                    );

                    entry.target.querySelectorAll('a, button').forEach(element => {
                        element.setAttribute('tabindex', isVisible ? '0' : '-1');
                    });
                });
            },
            {
            root: parent,
            threshold: [visibilityPercentage]
            }
        );

        slides.forEach(slide => observer.observe(slide));
    }

});